export default __webpack_public_path__ + "static/media/Ellipse 24 (2).30c4e2ef.png";